export const SHOP = window.Shopify ? window.Shopify.shop: '';
export const WINPAGE_DELAY = 300;
export const CAMPAIGN_TYPE_EMAIL = 'email';
export const CAMPAIGN_TYPE_FACEBOOK = 'facebook';
